'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cwUi = require('cw-ui');

var _AutomationName = require('../../../services/AutomationName');

var _AutomationName2 = _interopRequireDefault(_AutomationName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @type {React.StatelessComponent} */
var Flexbox = function Flexbox(props) {
  return _react2.default.createElement(_cwUi.CwFlexbox, (0, _assign2.default)({}, props, { cwId: _AutomationName2.default.get('flx', props.automationName) }));
};

Flexbox.propTypes = (0, _assign2.default)({
  /**
   * Element id used as selection and search for automation testing
   */
  automationName: _propTypes2.default.string
}, _cwUi.CwFlexbox.propTypes);

exports.default = Flexbox;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/managewidgets/components/flexbox/Flexbox.js
// module id = 776
// module chunks = 10